import React, { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';
import { useCart } from '../../../context/CartContext';
import { clearStoredAppliedCoupon } from '../../Cart/cartCouponStorage';
import { clearStoredCheckoutPayload } from './paymentCheckoutState';
import { clearStoredPendingOrderPayment } from './pendingOrderPaymentState';
import { clearPaymentFailure } from './paymentFailureState';
import './PaymentOutcome.css';

const PaymentSuccess = () => {
  const { state } = useLocation();
  const { clearCart } = useCart();
  const orderNumber = state?.orderNumber;
  const grandTotal = state?.grandTotal;
  const clearedRef = useRef(false);

  useEffect(() => {
    if (!orderNumber || clearedRef.current) return;
    clearedRef.current = true;
    clearCart();
    clearStoredCheckoutPayload();
    clearStoredAppliedCoupon();
    clearStoredPendingOrderPayment();
    clearPaymentFailure(orderNumber);
  }, [orderNumber, clearCart]);

  return (
    <div className="payment-outcome-page">
      <div className="payment-outcome-card">
        <FaCheckCircle className="payment-outcome-card__icon payment-outcome-card__icon--success" />
        <h1>Payment successful</h1>
        {orderNumber ? (
          <p className="payment-outcome-card__meta">
            Order <strong>#{orderNumber}</strong>
          </p>
        ) : (
          <p className="payment-outcome-card__meta">Your order has been placed.</p>
        )}
        {grandTotal != null && Number.isFinite(Number(grandTotal)) ? (
          <p className="payment-outcome-card__amount">
            Paid <strong>₹{Number(grandTotal).toFixed(2)}</strong>
          </p>
        ) : null}
        <div className="payment-outcome-card__actions">
          <Link to="/account/orders" className="btn-primary payment-outcome-card__cta">
            View my orders
          </Link>
          <Link to="/our-menu" className="payment-outcome-card__link">
            Continue shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
